export const compose =
  (...fns) =>
  (input) =>
    fns.reduce((prev, curr) => curr(prev), input)
